import { createContext, useContext } from "react";

export const InputPrefixContext = createContext(false);
InputPrefixContext.displayName = "InputPrefixContext";

export const useIsWithinCompassInputPrefix = () =>
  useContext(InputPrefixContext);
